import { gsap } from 'gsap';
import Splide from '@splidejs/splide';
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import { InitMap } from './InitMap';
import { GenericHandler } from './GenericPageHandler';
import { imagesLoaded } from 'imagesloaded';

export class ContactPageHandler extends GenericHandler {
    constructor(id) {
    	super(id);
    }

    init() {
		jQuery('.store__info table tr, .store__info h2, .store__info h3, .store__info ul').each((index, item) => {
			ScrollTrigger.create({
				trigger: item,
				start: "top 80%",
				onLeaveBack: self => self.disable(),
				onEnter: () => {
					gsap.fromTo(item, {y: 100, autoAlpha: 0}, {y: 0, autoAlpha: 1, duration: 0.8, ease: "power2.inOut"})
				}
			})
		})

		const endPosition = () => -(jQuery('.contact-form-section img')[0].offsetHeight - jQuery('.store__row')[0].offsetHeight);
		let mm = gsap.matchMedia();
		console.log(mm)
		mm.add("(min-width: 768px)", () => {
			const pinElm = document.querySelector(".contact-form-section img");

			const headings = gsap.utils.toArray(".contact-form-section .image");
			headings.forEach((heading) => {
				gsap.to(heading, {
				scrollTrigger: {
					id: "pin",
					trigger: heading,
					start: "top 100px",
					end: () => `bottom 100px+=${pinElm.getBoundingClientRect().height}px`,
					// markers: false,
					pin: true,
					pinSpacing: false,
					invalidateOnRefresh: true
				}
				})
			});
		})
		
    }

    ajax() {
	
	}

    destroy() {
    
    }

	events() {
		
	}

	transitions() {
		jQuery('.image').imagesLoaded(() => {
			gsap.fromTo('.image', {x: 50}, {x: 0,autoAlpha: 1, duration: 0.8, ease: "power2.inout"})
		})
    	gsap.fromTo('.contact-form', {y: 50}, {autoAlpha: 1, y: 0, duration: 0.8, ease: "power2.inout"})

	}
}